import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FikoYTService } from '../../../../../../fikoyt.service';
import { FikoThreeJsComponent } from '../../fiko-three-js.component';
import { CetvelComponent } from './cetvel/cetvel.component';
import { KumpasComponent } from './kumpas/kumpas.component';
import { AyarlarComponent } from './ayarlar/ayarlar.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CetvelMathService } from './cetvel/cetvel-math.service';
import { CetvelGeometryService } from './cetvel/cetvel-geometry.service';
import { gpuOlcumMotoru } from './gpu/GPUOlcumMotoru';

declare var $: any;

@Component({
  selector: 'fikoyt-fiko-olcum',
  templateUrl: './fiko-olcum.component.html',
  styleUrls: ['./fiko-olcum.component.scss'],
  imports: [CommonModule, FormsModule, CetvelComponent, KumpasComponent, AyarlarComponent],
  providers: [CetvelMathService, CetvelGeometryService],
  standalone: true
})
export class FikoOlcumComponent implements OnDestroy, AfterViewInit {

  /** 🎯 KÖK NEDEN FIX: DialogFiko (ngComponentOutlet) yolunda ac() hiç çağrılmaz —
   * olcumAleti setter'ı tetiklenmediği için kumpas.baslat() ÇALIŞMIYOR ve dialog
   * "ölü araç" ile açılıyordu (seçim yok / ölçüm 0). ViewChild'lar hazır olunca
   * varsayılan aleti başlat. ac() yolunda ise setter zaten çalışır (idempotent:
   * baslat başında bitir çağrılır). */
  ngAfterViewInit(): void {
    setTimeout(() => {
      if (!this.anaGosterim && this.parametreler?.anaGosterim) {
        this.anaGosterim = this.parametreler.anaGosterim;
      }
      if (this.anaGosterim && this._olcumAleti && this._olcumAleti !== 'Ayarlar') {
        this.olcumAleti = this._olcumAleti;
      }
    }, 0);
  }
  @ViewChild('FikoYTKumpas') FikoYTKumpas: KumpasComponent;
  @ViewChild('FikoYTCetvel') FikoYTCetvel: CetvelComponent;
  @ViewChild('FikoYTAyarlar') FikoYTAyarlar: AyarlarComponent;

  id_dialog = "dialogFikoOlcum" + this.FikoYT.fikoIdUret();
  subsList: Subscription[] = [];
  //---> RS+: Change Olaylarını Free Etmek İçin
  haritaOlaylar: Map<string, any> = new Map();
  // Dialog close event subscription
  private dialogCloseSub: Subscription | null = null;
  // Modal initialization kontrolü - modal sadece bir kez initialize edilir
  private modalBaslatildi = false;
  /** */
  private _olcumAleti: "Kumpas" | "Cetvel" | "Mezro" | "Ayarlar" | null = "Kumpas";
  public get olcumAleti(): "Kumpas" | "Cetvel" | "Mezro" | "Ayarlar" | any {
    return this._olcumAleti;
  }
  public set olcumAleti(v: "Kumpas" | "Cetvel" | "Mezro" | "Ayarlar" | any) {

    if (this.FikoYTKumpas) {
      this.FikoYTKumpas.bitir();
    }

    if (this.FikoYTCetvel) {
      this.FikoYTCetvel.bitir();
    }


    if (v == "Kumpas") {
      this.FikoYTKumpas.baslat(this.anaGosterim);
    }
    if (v == "Cetvel")
      this.FikoYTCetvel.baslat(this.anaGosterim);

    this._olcumAleti = v;
  }

  /** */
  @Input() anaGosterim: FikoThreeJsComponent;

  /** */
  private _pencere: any;

  @Input()
  public get pencere(): any {
    return this._pencere;
  }

  public set pencere(v: any) {
    // Wrapper nesnesinden dialog core instance'ını çıkar (backward compatibility için kontrol)
    this._pencere = v?.instance || v;

    // Mevcut subscription'ı temizle (dialog yeniden açıldığında tekrar subscription kurulmasını sağlar)
    if (this.dialogCloseSub) {
      this.dialogCloseSub.unsubscribe();
      this.dialogCloseSub = null;
    }

    // Pencere set edilince event listener'ını kur
    if (this._pencere && this._pencere.onDialogClose) {
      this.dialogCloseSub = this._pencere.onDialogClose.subscribe(() => {
        // Change detection hatasını önlemek için setTimeout ile async yap
        setTimeout(() => {
          this.temizle();
        }, 0);
      });

      // 🚀 Dialog açıldığında GPU motorunu başlat (ngComponentOutlet ile açılınca burası tetiklenir)
      this.initGPUMotor();
    }
  }

  /** */
  @Input() ayarlar: any = {
    width: '800px',
    height: '600px',
    closable: true,
    header: 'Fiko Ölçüm Aracı'
  };

  /** */
  @Input() parametreler: any = {};

  /** */
  kumpasEksen: any = null;

  /** */
  olcumSonuclari: any[] = [];

  /** */
  seciliOlcmeler: any = {
    Kumpas: null,
    Cetvel: null,
    Mezro: null
  };


  constructor(
    public readonly FikoYT: FikoYTService,
    public readonly CD: ChangeDetectorRef,
    public readonly mathService: CetvelMathService,
    public readonly geomService: CetvelGeometryService
  ) {

  }

  initComponent() {
    // Parametreleri ve ayarları birleştir
    if (this.parametreler && this.parametreler.anaGosterim) {
      this.anaGosterim = this.parametreler.anaGosterim;
    }
    if (this.parametreler && this.parametreler.ayarlar) {
      this.ayarlar = { ...this.ayarlar, ...this.parametreler.ayarlar };
    }
    if (this.parametreler && this.parametreler.kumpasEksen) {
      this.kumpasEksen = this.parametreler.kumpasEksen;
    }

    // 🚀 GPU Ölçüm Motorunu başlat (WebGPU > WebGL2 > WASM > CPU sırasıyla)
    this.initGPUMotor();

    // Not: Dialog Core close event listener, pencere setter'ında kurulur
  }

  /**
   * 🚀 GPU Ölçüm Motorunu başlat - WebGPU/WebGL2 otomatik seçilir
   */
  private async initGPUMotor(): Promise<void> {
    try {
      // Renderer varsa WebGL2 için kullan (FikoThreeJsComponent'te "sunucu" olarak adlandırılmış)
      const renderer = this.anaGosterim?.sunucu;
      await gpuOlcumMotoru.initialize(renderer);
    } catch (e) {
    }
  }

  public ac(anaGosterim?: FikoThreeJsComponent, ayarlar?: any) {
    if (anaGosterim) {
      this.anaGosterim = anaGosterim;
    }
    if (ayarlar) {
      this.ayarlar = { ...this.ayarlar, ...ayarlar };
    }

    // 🚀 GPU Ölçüm Motorunu başlat
    this.initGPUMotor();

    var _this = this;

    // Modal sadece ilk seferde initialize edilir
    if (!this.modalBaslatildi) {
      $("#" + this.id_dialog).modal({
        closable: this.ayarlar.closable || false,
        allowMultiple: true,
        detachable: false, // Modal'ın DOM'da kalmasını sağla (yeniden açılabilmesi için kritik)
        keyboardShortcuts: false, // ESC tuşunu devre dışı bırak
        onShow: function () {
          $("#" + _this.id_dialog).parent().removeClass('dimmer');
          $("#" + _this.id_dialog).draggable({ handle: ".baslikMove" });
          $("#" + _this.id_dialog).parent().css('width', _this.ayarlar.width || '800px');
          $("#" + _this.id_dialog).parent().css('height', _this.ayarlar.height || '600px');
        }
      });
      this.modalBaslatildi = true;
    }

    $("#" + this.id_dialog).modal('show');

    this.olcumAleti = 'Kumpas';
    this.CD.detectChanges();
  }



  /**
   * Dialog kapatıldığında çizgileri ve event'leri temizler
   */
  private temizle() {
    // Cetvel ve kumpas çizgilerini temizle
    if (this.FikoYTKumpas) {
      this.FikoYTKumpas.bitir();
    }
    if (this.FikoYTCetvel) {
      this.FikoYTCetvel.bitir();
    }

  }

  public kapa() {
    this.subsList.forEach(element => {
      if (element && element.unsubscribe) {
        element.unsubscribe();
      }
    });

    this.haritaOlaylar.forEach((value: any, key: string) => {
      if (value && typeof value === 'function') {
        value();
      }
    });

    // Dialog close subscription'ı temizle
    if (this.dialogCloseSub) {
      this.dialogCloseSub.unsubscribe();
      this.dialogCloseSub = null;
    }

    // Cetvel ve kumpas çizgilerini temizle
    this.temizle();

    // Dialog core'ın kapa metodunu çağır (pencere zaten instance'dır)
    if (this.pencere && typeof this.pencere.kapa === 'function') {
      try {
        this.pencere.kapa();
        return; // FikoDialogCore içindeyken kendi modal'ımızı kapatmaya çalışma
      } catch (error) {
        // Error handling
      }
    }

    // Sadece standalone modda (pencere yoksa) kendi modal'ımızı kapat
    try {
      $("#" + this.id_dialog).modal('hide');
    } catch (error) {
      // Error handling
    }
  }

  ngOnDestroy(): void {
    $("#" + this.id_dialog).remove();
    this.subsList.forEach(element => {
      if (element && element.unsubscribe) {
        element.unsubscribe();
      }
    });

    this.haritaOlaylar.forEach((value: any, key: string) => {
      if (value && typeof value === 'function') {
        value();
      }
    });

    // Dialog close subscription'ı temizle
    if (this.dialogCloseSub) {
      this.dialogCloseSub.unsubscribe();
      this.dialogCloseSub = null;
    }

    if (this.FikoYTKumpas) {
      this.FikoYTKumpas.bitir();
    }
    if (this.FikoYTCetvel) {
      this.FikoYTCetvel.bitir();
    }

    // 🚀 GPU Ölçüm Motorunu temizle
    gpuOlcumMotoru.dispose();

    // 🎯 NOT: Kalıcı ölçümler (FikoKaliciOlcumler) burada SİLİNMEZ!
    // Geçici ölçümler cetvel/kumpas component'lerinde session-based temizleniyor.
    // Kalıcı ölçümler kullanıcı isterse sağ tık menüsünden silinebilir.

    // Özellikleri temizle
    this.anaGosterim = null;
    this.pencere = null;
    this.kumpasEksen = null;
    this.olcumSonuclari = [];
    this.seciliOlcmeler = { Kumpas: null, Cetvel: null, Mezro: null };
  }

  /**
   * Ölçüm sonuçlarını kaydet
   */
  kaydetOlcmeler() {
    if (this.FikoYTKumpas && this.FikoYTKumpas.sonuc) {
      this.seciliOlcmeler.Kumpas = this.FikoYTKumpas.sonuc;
      this.olcumSonuclari.push({
        tip: 'Kumpas',
        veri: this.FikoYTKumpas.sonuc,
        zaman: new Date(),
        eksen: this.kumpasEksen
      });
    }

    if (this.FikoYTCetvel && this.FikoYTCetvel.sonuc) {
      this.seciliOlcmeler.Cetvel = this.FikoYTCetvel.sonuc;
      this.olcumSonuclari.push({
        tip: 'Cetvel',
        veri: this.FikoYTCetvel.sonuc,
        zaman: new Date(),
        eksen: this.kumpasEksen
      });
    }
  }

  /**
   * Ayarlar değiştirildiğinde çalışır
   */
  kaydetAyarlar(event?: any) {
    if (event) {
      // Ayarları güncelle
      this.ayarlar = { ...this.ayarlar, ...event };

      // 🎯 Kenar yakalama hassasiyeti (raycast piksel toleransı) — canlı uygula
      if (event.kenarHassasiyet !== undefined) {
        this.FikoYTKumpas?.kenarHassasiyetiUygula(event.kenarHassasiyet);
        this.FikoYTCetvel?.kenarHassasiyetiUygula(event.kenarHassasiyet);
      }

      // 🎯 Klasik uzatma çizgisi (sürüklemede paralel) seçimi — yeni sistem KALIR, sadece
      // uzatma (witness) çizgisi stili değişir: klasik=paralel (eski), kapalı=yüzeye değen (bbox).
      if (event.klasikOlcumStili !== undefined) {
        if (this.FikoYTKumpas) (this.FikoYTKumpas as any).klasikUzatma = event.klasikOlcumStili;
        if (this.FikoYTCetvel) (this.FikoYTCetvel as any).klasikUzatma = event.klasikOlcumStili;
      }

      // Görüntü ayarlarını güncelle
      if (event.cizimRengi || event.cizgiKalinligi || event.iziRengi || event.iziKalinligi || event.yaziRengi || event.yaziBoyutu) {
        if (this.FikoYTKumpas) {
          this.FikoYTKumpas.cizimRengi = event.cizimRengi || this.FikoYTKumpas.cizimRengi;
          this.FikoYTKumpas.cizgiKalinligi = event.cizgiKalinligi || this.FikoYTKumpas.cizgiKalinligi;
          this.FikoYTKumpas.iziRengi = event.iziRengi || this.FikoYTKumpas.iziRengi;
          this.FikoYTKumpas.iziKalinligi = event.iziKalinligi || this.FikoYTKumpas.iziKalinligi;
          this.FikoYTKumpas.yaziRengi = event.yaziRengi || this.FikoYTKumpas.yaziRengi;
          this.FikoYTKumpas.yaziBoyutu = event.yaziBoyutu || this.FikoYTKumpas.yaziBoyutu;
        }
        if (this.FikoYTCetvel) {
          this.FikoYTCetvel.cizimRengi = event.cizimRengi || this.FikoYTCetvel.cizimRengi;
          this.FikoYTCetvel.cizgiKalinligi = event.cizgiKalinligi || this.FikoYTCetvel.cizgiKalinligi;
          this.FikoYTCetvel.iziRengi = event.iziRengi || this.FikoYTCetvel.iziRengi;
          this.FikoYTCetvel.iziKalinligi = event.iziKalinligi || this.FikoYTCetvel.iziKalinligi;
          this.FikoYTCetvel.yaziRengi = event.yaziRengi || this.FikoYTCetvel.yaziRengi;
          this.FikoYTCetvel.yaziBoyutu = event.yaziBoyutu || this.FikoYTCetvel.yaziBoyutu;
        }
      }

      // ===== CATIA ÖLÇÜM ÇİZGİSİ AYARLARI =====
      if (event.olcumOffset !== undefined || event.okBoyutu !== undefined ||
          event.extensionLineGoster !== undefined || event.merkezIsaretiGoster !== undefined ||
          event.suruklenebilir !== undefined) {
        if (this.FikoYTKumpas) {
          if (event.olcumOffset !== undefined) this.FikoYTKumpas.olcumOffset = event.olcumOffset;
          if (event.okBoyutu !== undefined) this.FikoYTKumpas.okBoyutu = event.okBoyutu;
          if (event.extensionLineGoster !== undefined) this.FikoYTKumpas.extensionLineGoster = event.extensionLineGoster;
          if (event.merkezIsaretiGoster !== undefined) this.FikoYTKumpas.merkezIsaretiGoster = event.merkezIsaretiGoster;
          if (event.suruklenebilir !== undefined) this.FikoYTKumpas.suruklenebilir = event.suruklenebilir;
        }
        if (this.FikoYTCetvel) {
          if (event.olcumOffset !== undefined) this.FikoYTCetvel.olcumOffset = event.olcumOffset;
          if (event.okBoyutu !== undefined) this.FikoYTCetvel.okBoyutu = event.okBoyutu;
          if (event.extensionLineGoster !== undefined) this.FikoYTCetvel.extensionLineGoster = event.extensionLineGoster;
          if (event.merkezIsaretiGoster !== undefined) this.FikoYTCetvel.merkezIsaretiGoster = event.merkezIsaretiGoster;
          if (event.suruklenebilir !== undefined) this.FikoYTCetvel.suruklenebilir = event.suruklenebilir;
        }
      }

      // Hassasiyet ayarlarını güncelle
      if (event.hassasiyet || event.cemberTolerAnsi || event.cemberSapmaEsigi ||
          event.minOlcum || event.maxOlcum || event.parallelKontrol || event.yuzeyMesafeTolerAnsi) {
        if (this.FikoYTKumpas) {
          this.FikoYTKumpas.hassasiyet = event.hassasiyet || this.FikoYTKumpas.hassasiyet;
          this.FikoYTKumpas.cemberTolerAnsi = event.cemberTolerAnsi || this.FikoYTKumpas.cemberTolerAnsi;
          this.FikoYTKumpas.minOlcum = event.minOlcum || this.FikoYTKumpas.minOlcum;
          this.FikoYTKumpas.maxOlcum = event.maxOlcum || this.FikoYTKumpas.maxOlcum;
          this.FikoYTKumpas.cemberSapmaEsigi = event.cemberSapmaEsigi || this.FikoYTKumpas.cemberSapmaEsigi;
        }
        if (this.FikoYTCetvel) {
          this.FikoYTCetvel.hassasiyet = event.hassasiyet || this.FikoYTCetvel.hassasiyet;
          this.FikoYTCetvel.cemberTolerAnsi = event.cemberTolerAnsi || this.FikoYTCetvel.cemberTolerAnsi;
          this.FikoYTCetvel.cemberSapmaEsigi = event.cemberSapmaEsigi || this.FikoYTCetvel.cemberSapmaEsigi;
          this.FikoYTCetvel.minOlcum = event.minOlcum || this.FikoYTCetvel.minOlcum;
          this.FikoYTCetvel.maxOlcum = event.maxOlcum || this.FikoYTCetvel.maxOlcum;
          this.FikoYTCetvel.parallelKontrol = event.parallelKontrol || this.FikoYTCetvel.parallelKontrol;
          this.FikoYTCetvel.yuzeyMesafeTolerAnsi = event.yuzeyMesafeTolerAnsi || this.FikoYTCetvel.yuzeyMesafeTolerAnsi;
        }
      }

      // Koordinat basamak ayarlarını güncelle
      if (event.koordinatBas || event.alanBas || event.mesafeBas || event.aciBasamak) {
        if (this.FikoYTKumpas) {
          this.FikoYTKumpas.koordinatBas = event.koordinatBas || this.FikoYTKumpas.koordinatBas;
          this.FikoYTKumpas.alanBas = event.alanBas || this.FikoYTKumpas.alanBas;
        }
        if (this.FikoYTCetvel) {
          this.FikoYTCetvel.mesafeBas = event.mesafeBas || this.FikoYTCetvel.mesafeBas;
          this.FikoYTCetvel.aciBasamak = event.aciBasamak || this.FikoYTCetvel.aciBasamak;
          this.FikoYTCetvel.koordinatBas = event.koordinatBas || this.FikoYTCetvel.koordinatBas;
        }
      }

      // Birim ayarlarını güncelle
      if (event.secilenBirim || event.ondalikSayiBas || event.ciBirimFaktore || event.inchFaktore || event.mFaktore) {
        if (this.FikoYTCetvel) {
          this.FikoYTCetvel.secilenBirim = event.secilenBirim || this.FikoYTCetvel.secilenBirim;
          this.FikoYTCetvel.ondalikSayiBas = event.ondalikSayiBas || this.FikoYTCetvel.ondalikSayiBas;
          // 🔴 BUGFIX: Birim faktörlerini güncelle - yeni nesne oluştur
          const yeniBirimFaktore = { ...this.FikoYTCetvel.birimFaktore };
          if (event.ciBirimFaktore) yeniBirimFaktore['cm'] = event.ciBirimFaktore;
          if (event.inchFaktore) yeniBirimFaktore['inch'] = event.inchFaktore;
          if (event.mFaktore) yeniBirimFaktore['m'] = event.mFaktore;
          this.FikoYTCetvel.birimFaktore = yeniBirimFaktore;
        }
      }

      // Seçim modu filtrelerini güncelle
      if (event.secim1Turu || event.secim2Turu) {
        if (this.FikoYTKumpas) {
          this.FikoYTKumpas.secim1Turu = event.secim1Turu || this.FikoYTKumpas.secim1Turu;
          this.CD.detectChanges();
        }
        if (this.FikoYTCetvel) {
          this.FikoYTCetvel.secim1Turu = event.secim1Turu || this.FikoYTCetvel.secim1Turu;
          this.FikoYTCetvel.secim2Turu = event.secim2Turu || this.FikoYTCetvel.secim2Turu;
          this.CD.detectChanges();
        }
      }

      // Geçmiş ve limit ayarlarını güncelle
      if (event.olcumGecmisiLimiti || event.planeGeometriBoyu) {
        if (this.FikoYTCetvel) {
          this.FikoYTCetvel.olcumGecmisiLimiti = event.olcumGecmisiLimiti || this.FikoYTCetvel.olcumGecmisiLimiti;
          this.FikoYTCetvel.planeGeometriBoyu = event.planeGeometriBoyu || this.FikoYTCetvel.planeGeometriBoyu;
        }
      }
    }
  }


  /**
   * Tüm ölçümleri temizle
   */
  temizleOlcmeler() {
    this.olcumSonuclari = [];
    this.seciliOlcmeler = { Kumpas: null, Cetvel: null, Mezro: null };

    if (this.FikoYTKumpas) {
      this.FikoYTKumpas.sonuc = null;
      this.FikoYTKumpas.sonucTipi = null;
    }

    if (this.FikoYTCetvel) {
      this.FikoYTCetvel.sonuc = null;
      this.FikoYTCetvel.sonuc1Tipi = null;
      this.FikoYTCetvel.sonuc2Tipi = null;
    }

    this.CD.detectChanges();
  }

  /**
   * Eksen değiştir
   */
  eksenDegistir(eksen: any) {
    this.kumpasEksen = eksen;

    // Mevcut ölçümleri yenile
    if (this.FikoYTKumpas) {
      this.FikoYTKumpas.kumpasEksen = eksen;
      if (this.FikoYTKumpas.fikoSecim1) {
        this.FikoYTKumpas.sonuc = null;
        this.FikoYTKumpas.sonucTipi = null;
      }
    }

    if (this.FikoYTCetvel) {
      this.FikoYTCetvel.kumpasEksen = eksen;
      if (this.FikoYTCetvel.fikoSecim1) {
        this.FikoYTCetvel.sonuc = null;
        this.FikoYTCetvel.sonuc1Tipi = null;
        this.FikoYTCetvel.sonuc2Tipi = null;
      }
    }

    this.CD.detectChanges();
  }

  /**
   * Ölçüm sonuçlarını dışarı aktar
   */
  disariAktar(): string {
    const data = {
      tarih: new Date().toISOString(),
      olcumler: this.olcumSonuclari,
      eksen: this.kumpasEksen ? {
        name: this.kumpasEksen.name,
        pozisyon: this.kumpasEksen.position,
        rotasyon: this.kumpasEksen.rotation
      } : null
    };

    return JSON.stringify(data, null, 2);
  }
}
